var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "1200px",
      "transition": "dialog-bottom-transition",
      "fullscreen": _vm.isMobile
    },
    model: {
      value: _vm.dialogOpen,
      callback: function callback($$v) {
        _vm.dialogOpen = $$v;
      },
      expression: "dialogOpen"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t("nav.PartnerReportCreate.title")))]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-window', {
    model: {
      value: _vm.window,
      callback: function callback($$v) {
        _vm.window = $$v;
      },
      expression: "window"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": _vm.PartnerReportCreateDialogWindow.FORM
    }
  }, [_c('partner-report-create-form', {
    attrs: {
      "groupId": _vm.groupId,
      "vehicle": _vm.selectedVehicle
    },
    on: {
      "update:vehicle": function updateVehicle($event) {
        _vm.selectedVehicle = $event;
      },
      "created": _vm.setReport,
      "shared": _vm.setSharedContent,
      "submit": _vm.submit
    }
  })], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.PartnerReportCreateDialogWindow.SEND_MAIL
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm.PartnerReportCreateDialogWindow.SEND_MAIL === _vm.window ? _c('preselect-template-card', {
    ref: "templateCard",
    attrs: {
      "templateKey": _vm.PreselectTemplateKeysEnum.REQUEST_REPORT_ATTACHMENT_MAIL,
      "language": _vm.partner.language,
      "partnerId": _vm.partner.id,
      "from": [_vm.partner],
      "context": _vm.context,
      "to": _vm.to,
      "refs": _vm.mailRefs,
      "isTicketEnabled": true
    },
    on: {
      "sent": _vm.sent,
      "send": _vm.send
    }
  }) : _vm._e()], 1), _c('v-card-actions', {
    staticClass: "px-4"
  }, [_vm.sharedContent ? _c('v-btn', {
    attrs: {
      "elevation": 0
    },
    on: {
      "click": function click() {
        return _vm.sharedContent.copyUrl();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("timeLine.ActivityTimeLineItemShare.btnText")) + " ")]) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "success",
      "elevation": "0",
      "loading": _vm.isSendLoading
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.template.dialog.preview.send")) + " ")])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }